// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rAbvB9et5Sz4syCpCEI0{display:flex;flex-direction:column;padding:0}.qeVosTrGCnfuG3nMCjCQ{padding:0;margin-bottom:8px}`, "",{"version":3,"sources":["webpack://./src/widgets/CallPopUp/ui/CallInsightCards/CallInsightCardsNoteForm/ui/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,qBAAA,CACA,SAAA,CAGF,sBACE,SAAA,CACA,iBAAA","sourcesContent":[".wrap {\n  display: flex;\n  flex-direction: column;\n  padding: 0;\n}\n\n.messageField {\n  padding: 0;\n  margin-bottom: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `rAbvB9et5Sz4syCpCEI0`,
	"messageField": `qeVosTrGCnfuG3nMCjCQ`
};
export default ___CSS_LOADER_EXPORT___;
